module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0169.jpg?v=4dfbe32d";